import {AbstractBprocRequest} from "./base/AbstractBprocRequest";
import {PersonGroupExt} from "./base/base$PersonGroupExt";
import {FileDescriptor} from "./base/sys$FileDescriptor";
import {OrderRegister} from "./kms_OrderRegister";
import {DicRequestStatus} from "./base/tsadv$DicRequestStatus";

export class OrderChangeRequest extends AbstractBprocRequest {
  static NAME = "kzm_OrderChangeRequest";
  initiatorPersonGroup?: PersonGroupExt
  personGroup?: PersonGroupExt
  comment?: string | null;
  files?: FileDescriptor[];
  order?: OrderRegister;
  requestDate: string | null;
  requestNumber: number | null;
  status: DicRequestStatus;
  type: "CHANGE" | "CANCEL";
}

export type OrderChangeRequestViewName =
  | "_base"
  | "_local"
  | "_minimal"
